import React from 'react';
import ReactDOM from 'react-dom';
import { ua } from '../ua';

type AnyObj = { [key: string]: any };

const wrapHeight = 35;
const paddingTop = wrapHeight;
const paddingLeft = wrapHeight
class H5Title {
  wrapHeight: number = wrapHeight;
  className: string = 'ui-title-placeholder';
  // config 默认配置，同步weapp-profile BaseSetting TitleSetting 标题设置页面默认配置
  config: AnyObj = {
    showH5Title: false, // 默认关闭
    thirdPartyAppSetting: 'whiteList',
    whiteLists: [
      { id: '1', name: 'Safari', browser: 'Safari' },
      { id: '2', name: '谷歌', browser: 'Chrome' },
      { id: '3', name: 'QQ浏览器', browser: 'QQBrowser' },
      { id: '4', name: 'Microsoft Edge', browser: 'Edge' },
      { id: '5', name: 'Microsoft Edge', browser: 'Edg' },
      { id: '6', name: '搜狗浏览器', browser: 'Sogou' },
    ],
    blackLists: [
      { id: '1', name: 'UC浏览器', browser: 'UC' },
      { id: '2', name: '夸克浏览器', browser: 'Quark' },
      { id: '3', name: '百度浏览器', browser: 'Baidu' },
      { id: '4', name: '微信', browser: 'MicroMessenger' },
      { id: '5', name: '企业微信', browser: 'wxwork' },
      { id: '6', name: 'QQ', browser: 'QQ' },
      { id: '7', name: '钉钉', browser: 'DingTalk' },
      { id: '8', name: '飞书', browser: 'Lark' },
    ],
  }
  show: boolean = false;
  rootStyle: AnyObj = {}; // 记录标准样式，卸载Title后还原
  observer?: MutationObserver;
  mustHide: boolean = false;
  isHorizontal: boolean = false // 是否是横屏

  setHorizontal = (isHorizontal?: boolean) => {
    this.isHorizontal = !!isHorizontal
  }

  hasRegister = () => {
    if (/wea_link_keep_hide_h5_title/.test(window.location.href)) {
      return false; // 通过url强制隐藏标题
    }
    if (!(ua.device !== 'PC' && !window.navigator.userAgent.match(/weapp/i))) return false; // pc端及App内不显示
    let teamsConfig = window?.TEAMS?.globalConfig?.h5TitleSetting;
    if (teamsConfig) teamsConfig = JSON.parse(teamsConfig);
    const configs = teamsConfig || this.config;
    if (!configs?.showH5Title) return false;
    // 黑白名单读取
    const { thirdPartyAppSetting, whiteLists, blackLists } = configs;
    if (thirdPartyAppSetting !== 'blackList') {
      return whiteLists?.find((l: AnyObj) => l.browser?.toLocaleLowerCase() === ua?.browser?.toLocaleLowerCase());
    } else {
      return !blackLists?.find((l: AnyObj) => l.browser?.toLocaleLowerCase() === ua?.browser?.toLocaleLowerCase());
    }
  }
  /**
   * 注册H5页面标题
   */
  registerH5Title = () => {
    if (!this.hasRegister()) return;
    const title = window.document?.title;
    if (!title) return;
    const dom = document.querySelector(`[id="${this.className}-container"]`) as HTMLElement;
    // 窗口宽高
    const { clientWidth, clientHeight } = document.body
    if (!dom) {
      let wrapDom = document.createElement('div');
      wrapDom.id = `${this.className}-container`;
      // 定位
      wrapDom.style.position = 'fixed';
      wrapDom.style.zIndex = '999'; // Dialog RouteLayout 998
      wrapDom.style.top = '0px';
      wrapDom.style.left = '0px';

      // 字体大小跟随全局设置
      wrapDom.style.fontSize = 'var(--font-size-lg)';
      wrapDom.style.background = '#666';
      wrapDom.style.color = '#fff';

      // 定高(35px)
      wrapDom.style.height = `${wrapHeight}px`;
      wrapDom.style.lineHeight = `${wrapHeight}px`;
      wrapDom.style.textAlign = 'center';
      wrapDom.style.padding = '0 10px';
      wrapDom.style.width = '100%';

      // 文字超长省略
      wrapDom.style.overflow = 'hidden';
      wrapDom.style.textOverflow = 'ellipsis';
      wrapDom.style.whiteSpace = 'nowrap';

      // 横屏模式特使处理
      if (this.isHorizontal) {
        wrapDom.style.width = `${clientHeight}px`;
        wrapDom.style.top = `${(clientHeight - wrapHeight) / 2}px`;
        wrapDom.style.left = `${-(clientHeight - wrapHeight) / 2}px`;
        wrapDom.style.transform = `rotate(-90deg)`
      }
      document.body.appendChild(wrapDom);
    } else {
      if (!this.isHorizontal) {
        dom.style.width = '100%';
        dom.style.top = '0px';
        dom.style.left = '0px';
        dom.style.transform = 'unset';
      } else {
        dom.style.width = `${clientHeight}px`;
        dom.style.top = `${(clientHeight - wrapHeight) / 2}px`;
        dom.style.left = `${-(clientHeight - wrapHeight) / 2}px`;
        dom.style.transform = `rotate(-90deg)`
      }
    }
    this.adjustStandardStyle();
    this.render();
  }
  // 调整标准样式
  adjustStandardStyle = () => {
    if (!this.hasRegister()) return;
    const rootDom = window.document.getElementById('root');
    if (!this.isHorizontal) {
      if (!('paddingTop' in this.rootStyle)) {
        this.rootStyle = {
          paddingTop: rootDom?.style.paddingTop,
        };
        // this.rootStyle.paddingTop = rootDom?.style.paddingTop
      }
      if (rootDom) {
        rootDom.style.paddingTop = `${wrapHeight}px`;
        rootDom.style.paddingLeft = this.rootStyle.paddingLeft;
      }
    } else {
      if (!('paddingLeft' in this.rootStyle)) {
        this.rootStyle = {
          paddingLeft: rootDom?.style.paddingLeft,
        };
        // this.rootStyle.paddingLeft = rootDom?.style.paddingLeft
      }
      if (rootDom) {
        rootDom.style.paddingLeft = `${wrapHeight}px`;
        rootDom.style.paddingTop = this.rootStyle.paddingTop;
      }
    }
    this.addListener();
  }
  // 监听dom树变化
  listener = () => {
    const title = window.document?.title;
    if (title) {
      const fixedDoms = document.querySelectorAll(`[class~="${this.className}"]`);
      fixedDoms?.forEach((dom: any) => {
        if (!this.isHorizontal) {
          if (dom.style.paddingTop) dom.setAttribute('old-padding-top', dom.style.paddingTop); // 备份原dom上的内联样式
          dom.style.paddingTop = `${paddingTop}px`;
          dom.style.paddingLeft = 'unset';
        } else {
          if (dom.style.paddingLeft) dom.setAttribute('old-padding-left', dom.style.paddingLeft); // 备份原dom上的内联样式
          dom.style.paddingLeft = `${paddingLeft}px`;
          dom.style.paddingTop = 'unset';
        }
      });
    } else {
      this.observer?.disconnect();
    }
  }
  addListener = () => {
    const targetNode = document.querySelector('body'); // 配置器的配置：需要监听的变动 
    const config = { characterData: true, subtree: true, childList: true } // 变动时回调
    if (targetNode) {
      this.observer = new MutationObserver(this.listener) // 监听目标节点
      this.observer.observe(targetNode, config)
    }
  }

  // --------------------卸载 H5 页面标题--------------------
  unRegisterH5Title = () => {
    if (!this.hasRegister()) return;
    this.recoverStandardStyle();
    const wrapDom = document.querySelector(`[id="${this.className}-container"]`);
    console.info('unRegisterH5Title')
    if (wrapDom) {
      const unmount = ReactDOM.unmountComponentAtNode(wrapDom);
      if (unmount && wrapDom.parentNode) {
        wrapDom.parentNode.removeChild(wrapDom);
        console.info('removeChildremoveChild')
      }
    }
  }
  recoverStandardStyle = () => {
    if (!this.hasRegister()) return;
    const rootDom = window.document.getElementById('root');
    if (!this.isHorizontal) {
      rootDom && (rootDom.style.paddingTop = this.rootStyle?.paddingTop || '');
    } else {
      rootDom && (rootDom.style.paddingLeft = this.rootStyle?.paddingLeft || '');
    }
    this.rootStyle = {};
    this.removeListener();
  }
  removeListener = () => {
    this.observer?.disconnect();
    const fixedDoms = document.querySelectorAll(`[class~="${this.className}"]`);
    fixedDoms?.forEach((dom: any) => {
      if (!this.isHorizontal) {
        const oldPaddingTop = dom.getAttribute('old-padding-top');
        dom.style.paddingTop = oldPaddingTop || '';
      } else {
        const oldPaddingLeft = dom.getAttribute('old-padding-left');
        dom.style.paddingLeft = oldPaddingLeft || '';
      }
    });
  }

  // --------------------render--------------------
  render = () => {
    if (!this.hasRegister()) return;
    const title = window.document?.title;
    const wrapDom = document.querySelector(`[id="${this.className}-container"]`);
    if (wrapDom) {
      if (title) {
        this.show = true;
        ReactDOM.render((<>{title}</>), wrapDom);
      } else {
        this.show = false;
        this.unRegisterH5Title();
      }
    }
  }
}

export default H5Title;

export type H5TitleType = Pick<H5Title, keyof H5Title>;